export default __webpack_public_path__ + "static/media/werender_shoes.75159528.png";